import React from "react";
import ReactDOM from "react-dom";
import SpecialToolsApp from "./SpecialToolsApp";
import SearchApp from "./SearchApp";

const searchAppElem = document.querySelector(".search-app");
if (searchAppElem) {
  ReactDOM.render(
    <React.StrictMode>
      <SearchApp />
    </React.StrictMode>,
    searchAppElem
  );
}

const specialToolsAppDiv = document.querySelector(".special-tools-app");
if (specialToolsAppDiv) {
  ReactDOM.render(
    <React.StrictMode>
      <SpecialToolsApp />
    </React.StrictMode>,
    specialToolsAppDiv
  );
}